<template>
  <div>
    <v-sheet height="100%">
      <v-img :src="require('@/assets/login/background.jpg')" max-height="100vh">
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-col cols="10">
            <v-card>
              <v-row>
                <v-col cols="5" class="pa-10">
                  <div>
                    <div class="mb-10">
                      <v-row class="justify-center mb-5">
                        <v-img
                          :src="require('@/assets/login/logo.png')"
                          max-width="100"
                        ></v-img>
                      </v-row>
                      <div class="text-center primary--text">
                        <h3 class="font-weight-light">SINGLE SIGN ON</h3>
                        <h2>ID.ASN PEMERINTAH KABUPATEN POHUWATO</h2>
                      </div>
                    </div>

                    <div class="mb-10" v-if="alertG">
                      <v-alert v-model="alertG" type="error" dense dismissible>
                        {{ alertM }}
                      </v-alert>
                    </div>
                  </div>

                  <form>
                    <v-text-field
                      v-model="username"
                      label="Nomor Induk Pegawai"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="password"
                      label="Password"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show ? 'text' : 'password'"
                      @click:append="show = !show"
                      outlined
                    ></v-text-field>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-btn
                          class="mb-3"
                          color="primary"
                          dark
                          block
                          @click="login()"
                        >
                          <span class="font-weight-black"> LOGIN </span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </form>
                </v-col>

                <v-col cols="7" class="pa-10" style="background-color: #e0e0e0">
                  <div>
                    <div class="mb-5">
                      <h2>PENGUMUMAN</h2>
                    </div>

                    <div class="mb-5">
                      <v-card class="pa-5">
                        <div>
                          <h3>Imbauan Penyelesaian Jenis Anomali Data SKP</h3>
                        </div>

                        <div>
                          Jenis anomali data ini disebabkan terdapatnya ASN yang
                          tidak membuat/melaporkan atau belum menyelesaikan
                          proses pengisian/penilaian SKP untuk periode penilaian
                          tahun sebelumnya.
                        </div>

                        <v-divider class="my-3"></v-divider>

                        <div>
                          <v-row no-gutters>
                            <v-icon left>mdi-calendar</v-icon>
                            <div>
                              <i>5 Januari 2026</i>
                            </div>

                            <v-spacer></v-spacer>

                            <div>
                              <i>Lihat Selengkapnya</i>
                            </div>
                          </v-row>
                        </div>
                      </v-card>
                    </div>

                    <div>
                      <v-btn color="primary" class="mr-3" @click="beranda()">BERANDA</v-btn>
                      <v-btn color="primary">BANTUAN</v-btn>
                    </div>

                    <div style="margin-top: 120px">
                      <div class="mb-2">
                        <v-row no-gutters>
                          <v-img
                            :src="require('@/assets/login/logo-new.png')"
                            max-width="100"
                            class="mr-5"
                          ></v-img>

                          <v-img
                            :src="require('@/assets/login/logo-siasn.png')"
                            max-width="100"
                          ></v-img>
                        </v-row>
                      </div>

                      <div>
                        <small>
                          <i>
                            ASN Pemerintah Kabupaten Pohuwato wajib menjaga
                            kerahasiaan username dan password masing-masing saat
                            menggunakan SSO
                          </i>
                        </small>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-img>
    </v-sheet>
  </div>
</template>

<script>
export default {
  data: () => ({
    show: false,
    alertG: false,

    alertM: "",
    userEmail: "",
    userPassword: "",

    username: "",
    password: "",
  }),

  methods: {
    login() {
      const data = {
        username: this.username,
        password: this.password,
      };

      const url =
        process.env.VUE_APP_AUTH +
        "authorize?client_id=" +
        this.$route.query.client_id +
        "&response_type=token";

      this.http
        .post(url, data)
        .then((res) => {
          if (res.data.success) {
            this.alertG = false;
            window.location.href = res.data.mapData.redirect_uri;
          } else {
            this.alertG = true;
            this.alertM = res.data.message;
          }
        })
        .catch((err) => {
          console.log(err);
          this.alertG = true;
          this.alertM = err.response.data.message;
        });
    },

    lupapass() {
      this.$router
        .push("/resetpassword?client_id=" + this.$route.query.client_id)
        .catch(() => {});
    },

    beranda(){
      window.location.href = 'https://idasn.pohuwatokab.go.id/opendata'
    }
  },
};
</script>
